import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Plus, Users, MapPin } from "lucide-react";
import api from "../lib/api";

export default function Ensembles() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);

  const refresh = () => api.get("/ensembles").then(({ data }) => setItems(data || []));
  useEffect(() => { refresh(); }, []);

  return (
    <div className="space-y-5" data-testid="ensembles-page">
      <div className="flex items-end justify-between gap-3 flex-wrap">
        <div>
          <div className="label-overline">Ensembles</div>
          <h1 className="font-heading text-3xl font-bold tracking-tight mt-1">Your groups</h1>
          <p className="text-ink-600 text-sm mt-1">Run an orchestra, choir, or ensemble. Schedule rehearsals, share parts, see who's coming.</p>
        </div>
        <button onClick={() => navigate("/ensembles/new")} className="btn-primary text-sm" data-testid="new-ensemble-btn"><Plus size={16} /> New ensemble</button>
      </div>

      {items.length === 0 ? (
        <div className="card-base p-8 text-center" data-testid="ensembles-empty">
          <Users className="mx-auto text-sage-500" size={28} />
          <div className="mt-3 font-heading font-semibold">No ensembles yet.</div>
          <p className="text-sm text-ink-600 mt-1">Create one and invite the people you play with.</p>
          <button onClick={() => navigate("/ensembles/new")} className="btn-primary text-sm mt-4" data-testid="empty-new-ensemble-btn"><Plus size={16} /> Create your first ensemble</button>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 gap-3">
          {items.map((e) => (
            <Link key={e.id} to={`/ensembles/${e.id}`} className="card-base p-5 hover:-translate-y-[1px] transition" data-testid={`ensemble-${e.id}`}>
              <div className="font-heading text-lg font-semibold">{e.name}</div>
              {e.location && <div className="text-xs text-ink-500 inline-flex items-center gap-1.5 mt-1"><MapPin size={12} /> {e.location}</div>}
              {e.description && <p className="text-sm text-ink-600 mt-2 line-clamp-2">{e.description}</p>}
              <div className="mt-3 flex gap-2">
                <span className="pill bg-sage-100 text-sage-700"><Users size={12} /> {e.member_count} member{e.member_count === 1 ? "" : "s"}</span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
